import $ from 'jquery';

function Carousel(){
    // selectors
    var boxDevis = $('.box-devis');
    var btnBoxDevis = boxDevis.find('button.openModal');
    var inputPostcode = boxDevis.find('.inputPostcode');
    var carousel = $('.carousel');
    var carouselHeader = carousel.find('.carousel__header');
    var carouselSteps = carousel.find('.steps');
    var carouselFooter = carousel.find('.carousel__footer');
    var carouselRadioDiv = carousel.find('.radio-div');
    var carouselRadioInput = carousel.find('.radio-div').find('input');
    var inputPostCodeCarousel = carousel.find('input#code_postal');
    var inputVilleCarousel = carousel.find('input#ville');
    var close = carousel.find('.closeModal');
    var prev = carouselFooter.find(".prev");
    var next = carouselFooter.find(".next");
    var slider = carousel.find('.carousel__slider');
    var slide = slider.find('.slide');
    var numberOfSlides = slide.length;
    var slidesPosition = 1;
    var isFilled = 0;
    var inputs;
    var inputsRadio;
    var numberOfInputs;
    var isBtnAbled;
    

    // events
    setUpCarousel();
    next.on('click', nextSlide);
    prev.on('click', prevSlide);
    close.on('click', function(){
        $('.modal').css('display', 'none');
        $("body").css("overflow","auto");
        $("body").css("overflow-x","hidden");
    });
    carousel.find('input, textarea, select').on('input', btnDisabled);
    btnBoxDevis.on('click', setPostCode);
    carouselRadioDiv.on('click', btnDisabled);
    carouselRadioInput.on('input', btnDisabled);
    
    

    // /* autoselect radio input */
    // function autoSelectRadioInput(){
    //     $(this).find('input').prop( "checked", true );
    //     isFilled = 1;
    // }

    // functions
    function setUpCarousel(){
        // ajouter les éléments 'Etape x sur y'
        carouselHeader.find('.currentSlide').html(slidesPosition);
        carouselHeader.find('.numberOfSlides').html(numberOfSlides);
        // ajouter les steps (bulles)
        for(let i=1; i<=numberOfSlides; i++){
            carouselSteps.append( '<div class="step"></div>' );
            // var step = carouselSteps.find('.step');
            var firstRound = carouselSteps.find('.step:first-child');
        }
        // donner la classe active au premier rond
        firstRound.addClass('active');
        // désactiver et cacher le premier bouton prev
        prev.css('visibility', 'hidden');
        // afficher le premier slide
        slider.find(`.slide:nth-child(${slidesPosition})`).css('display', 'block');
    }

    function nextSlide(){
        if(slidesPosition < numberOfSlides){
            
            slider.find(`.slide:nth-child(${slidesPosition})`).css('display', 'none');
            slidesPosition++;
            // console.log(slidesPosition);
            slider.find(`.slide:nth-child(${slidesPosition})`).css('display', 'block');

            btnDisabled();
            
            prev.css('visibility', 'visible');
            carouselHeader.find('.currentSlide').html(slidesPosition);
            carouselSteps.find('.step').removeClass('active');
            carouselSteps.find(`.step:nth-child(${slidesPosition})`).addClass('active');
            for(let i=slidesPosition; i>0; i--){
                carouselSteps.find(`.step:nth-child(${i})`).addClass('done');
            }

            if(slidesPosition == numberOfSlides){
                next.html('Envoyer');
                setTimeout(function(){
                    next.removeAttr("type").attr("type", "submit");
                }, 200);
            }
            
        }
    }

    function prevSlide(){
        if(slidesPosition > 1){
            slider.find(`.slide:nth-child(${slidesPosition})`).css('display', 'none');
            slidesPosition--;
            // console.log(slidesPosition);
            slider.find(`.slide:nth-child(${slidesPosition})`).css('display', 'block');

            btnDisabled();
            
            if(slidesPosition == 1){
                prev.css('visibility', 'hidden');
            }
            carouselHeader.find('.currentSlide').html(slidesPosition);
            carouselSteps.find('.step').removeClass('active');
            carouselSteps.find(`.step:nth-child(${slidesPosition})`).removeClass('done').addClass('active');
            for(let i=slidesPosition; i<=numberOfSlides; i++){
                carouselSteps.find(`.step:nth-child(${i})`).removeClass('done');
            }

            next.html('Suivant <i class="fa-solid fa-angle-right"></i>');
            next.removeAttr("type").attr("type", "button");
        }
    }


    function btnDisabled(){
        inputs = carousel.find(`.slide:nth-child(${slidesPosition})`).find('input:not(#site):not([type="radio"]):not([type="hidden"]), textarea, select');
        inputsRadio = carousel.find(`.slide:nth-child(${slidesPosition})`).find('input[type="radio"]');
        numberOfInputs = inputs.length;

        if(carousel.find(`.slide:nth-child(${slidesPosition})`).hasClass('radioSlide')){
            numberOfInputs = 1;
        }

        if($(this).find('input').is(':radio')){
            $(this).find('input').prop( "checked", true );
        }
        // if($(this).is(':radio')){
        //     $(this).prop( "checked", true );
        // }
        

        inputs.each(function(){
            if($(this).is(':checkbox')){
                if($(this).is(':checked')){
                    isFilled++;
                }
            }
            else{
                if($(this).val() !== ""){
                    isFilled++;
                }
            }
        });
        inputsRadio.each(function(){
            if($(this).is(':checked')){
                isFilled++;
            }
        })

        // console.log(isFilled + "/" + numberOfInputs);

        if(isFilled == numberOfInputs){
            isBtnAbled = true;
        }else{
            isBtnAbled = false;
        }
        isFilled = 0;

        checkPostcode(inputs);

        checkEmail(inputs);

        checkPhone(inputs);


        if(isBtnAbled){
            next.prop("disabled", false);
        }else{
            next.prop("disabled", true);
        }
    }

    function checkPostcode(inputs){
        if(inputs.toArray().filter(function(e) { return e.name === 'code_postal'; }).length > 0){
            var codePostal = $('#code_postal').val();
            if(codePostal !== "" && codePostal.length !== 4){
                $('#comment_code_postal').html("Le code postal doit contenir 4 chiffres");
                isBtnAbled = false;
            }
            else{
                $('#comment_code_postal').html("");
            }  
        }

    }

    function checkEmail(inputs){
        if(inputs.toArray().filter(function(e) { return e.name === 'email'; }).length > 0){
            function isEmail(email) {
                var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                return regex.test(email);
            }
            var emailadress = $('#email').val();
            if(emailadress !== "" && !isEmail(emailadress)){
                $('#comment_email').html("L'addresse mail n'est pas valide");
                isBtnAbled = false;
            }
            else{
                $('#comment_email').html("");
            }  
        }

    }

    function checkPhone(inputs){
        if(inputs.toArray().filter(function(e) { return e.name === 'telephone'; }).length > 0){
            function isPhone(phone) {
                var regex = /^([0-9 ]{9,13})+$/;
                return regex.test(phone);
            }
            var telephone = $('#telephone').val();
            if(telephone !== "" && !isPhone(telephone)){
                $('#comment_telephone').html("Le numéro de téléphone n'est pas valide");
                isBtnAbled = false;
            }
            else{
                $('#comment_telephone').html("");
            }
        }
    }

    function setPostCode(e){
        var postcodeInputValue = inputPostcode.val();
        var villeInputValue = e.target.dataset.ville;
        // console.log(villeInputValue);
        inputPostCodeCarousel.val(postcodeInputValue);
        inputVilleCarousel.val(villeInputValue);
    }
}

export default Carousel;